import { Platform } from 'react-native';

export const strToNumber = (value: string): number => {
	return parseFloat(value?.replace(/[^-\d.]/g, '') || '0');
};

export const toCurrency = (
	value = 0,
	options?: {
		showDollar?: boolean,
		unit?: string,
		maximumFractionDigits?: number,
		useDynamicPrecision?: boolean,
		showTrailingZeros?: boolean,
		showCommas?: boolean,
		showSign?: boolean,
		reduce?: (value: number) => string,
	},
	fallbackString = ''
): string => {
	if (value == null) {
		return fallbackString;
	}

	let stringResult = value.toString() ;

	const {
		unit = '',
		useDynamicPrecision = false,
		showDollar = false,
		showCommas = true,
		showTrailingZeros = true,
		showSign = false,
		reduce
	} = options ?? {}

	let maximumFractionDigits = options?.maximumFractionDigits ?? 2;

	if (reduce) {
		return reduce(value);
	}

	if (useDynamicPrecision) {
		if (value >= 100) {
			maximumFractionDigits = 2;
		} else if (value < 100 && value >= 1) {
			maximumFractionDigits = 3;
		} else {
			maximumFractionDigits = 8;
		}
	}

	stringResult = value.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: showTrailingZeros ? 2 : 0,
		maximumFractionDigits,
	}).replace('$', '').replace('-', '');


	const isDust = (stringResult === '0.00' || stringResult === '0') && value > 0;

	if (!showCommas) {
		stringResult = stringResult.replace(',', '');
	}

	if (unit) {
		stringResult = stringResult + ' ' + unit
	}

	if (showDollar) {
		stringResult = '$' + stringResult;
	}

	if (showSign || value < 0) {
		stringResult = `${value < 0 ? '-' : '+'}${stringResult}`
	}

	if (isDust) {
		stringResult = `< ${stringResult.replace('0.00', '0.01')}`
	}

	return stringResult;
};

// breaking asset trade rounding
export const toCurrencyRound = (
	value: number = 0,
	useDollar: boolean = true,
	minimumFractionDigits: number = 2,
	maximumFractionDigits: number = 2
): string => {
	let returnString = value.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits,
		maximumFractionDigits,
	});

	const [num, decimals] = returnString.split('.');
	const firstTwo = decimals?.slice(0, 2) || '';
	let afterTwo = decimals?.slice(2) || '';

	if (afterTwo?.length) {
		afterTwo = afterTwo.replace(/0+$/, '');
	}

	returnString = `${num}.${firstTwo}${afterTwo}`;

	if (Platform.OS === 'android') {
		returnString = '$' + returnString;
	}

	if (useDollar) {
		return returnString;
	}

	return returnString.replace('$', '');
};

export const toPercentage = (decimal: number, digits: number = 2): string => {
	if (decimal < 0) {
		return `${decimal?.toFixed(digits) || `0${digits ? '.' : ''}${'0'.repeat(digits)}`}%`;
	}

	return `+${decimal?.toFixed(digits) || `0${digits ? '.' : ''}${'0'.repeat(digits)}`}%`;
};

export const toPercentageWhole = (decimal: number): string => {
	const percentage = parseFloat((decimal * 100).toFixed(2));

	return `${percentage}%`;
};
